const ChevronDownIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      fill="inherit"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.96 9 7 9.966 12 15l5-5.034L16.04 9 12 13.07 7.956 9h.002Z" />
    </svg>

  );
};

export default ChevronDownIcon;
